import React from 'react';

export default function About() {
  return (
    <React.Fragment>
    <main id="main">
    
 
      

    <div class="aboutnew">
      <section id="about">
        <div class="container" >
  
          <header class="section-header">
            <h3>About Us</h3>
            <p>Ananya Financial & Advisory Services is a dedicated group of experienced former Senior Bankers. Our team works with a vast network of 55+ banks and NBFCs, to make your banking experience hassle-free.</p>
          </header>
  
          <div class="row about-cols">
  
            <div class="col-md-4" >
              <div class="about-col">
                <div class="img">
                  <img src="assets/img/about-mission.jpg" alt="" class="img-fluid" />
                  <div class="icon"><i class="bi bi-bar-chart"></i></div>
                </div>
                <h2 class="title">Our Mission</h2>
                <p>
                To facilitate a smooth and pleasant banking experience through our optimal solutions for all your financial needs.</p>
              </div>
            </div>
  
            <div class="col-md-4" >
              <div class="about-col">
                <div class="img">
                  <img src="assets/img/about-vision.jpg" alt="" class="img-fluid" />
                  <div class="icon"><i class="bi bi-brightness-high"></i></div>
                </div>
                <h2 class="title">Our Plan</h2>
                <p>
                We abide by a “Customer First” ideology wherein we work hard to offer you fast, efficient and outstanding services. We commit ourselves to push you closer to your goals and ambitions.
                </p>
              </div>
            </div>
  
            <div class="col-md-4" >
              <div class="about-col">
                <div class="img">
                  <img src="assets/img/about-plan.jpg" alt="" class="img-fluid" />
                  <div class="icon"><i class="bi bi-calendar4-week"></i></div>
                </div>
                <h2 class="title">Our Vision</h2>
                <p>
                To build a closely-knit network across the country that is committed to providing exclusive financial services for the holistic growth of our clients.

                </p>
              </div>
            </div>
  
          </div>
  
        </div>
      </section>  
      </div>
      </main>
      </React.Fragment >
  )
}
